import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { ENTERPRISES_COLLECTION, PATHS_COLLECTION, TYPES_COLIS_COLLECTION } from "../constants/collections";
import { ENTERPRISE_DOC_ID } from "../constants/configs";

const getPaths = async () => {
  const ref = query(collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, PATHS_COLLECTION));
  const querySnapshot = await getDocs(ref);
  const paths = querySnapshot.docs.map((doc) => doc.data());
  return paths;
};

const getTypesColis = async (pathId) => {
  const ref = collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, TYPES_COLIS_COLLECTION);
  const q = query(ref, where('pathId', '==', pathId));

  const querySnapshot = await getDocs(q);
  const typesColis = querySnapshot.docs.map((doc) => doc.data());
  return typesColis;
};


const getAllTypesColis = async () => {
  const ref = collection(db, ENTERPRISES_COLLECTION, ENTERPRISE_DOC_ID, TYPES_COLIS_COLLECTION);
  const q = query(ref);

  const querySnapshot = await getDocs(q);
  const typesColis = querySnapshot.docs.map((doc) => doc.data());
  return typesColis;
};

const getAsignPath = async () => {
  const typeColisPathPromise = [await getAllTypesColis(), await getPaths()]
  const [alltypeColis, allPaths] = await Promise.allSettled(typeColisPathPromise)

  const getIdtypeColis = alltypeColis.value.map(typeColis => typeColis.pathId)
  const paths = allPaths.value.filter((path) => getIdtypeColis.includes(path.id))

  return paths
}

export { getPaths, getTypesColis, getAllTypesColis, getAsignPath };
